/* eslint no-unused-vars: "off" */
import 'swiper/src/less/swiper.less';
import './slider.less';

window.addEventListener('load', () => {
  const swiperContext = require('bundle-loader?name=slider!Swiper');

  swiperContext((Swiper) => {
    const mainSlider = new Swiper('.swiper-container.c-main-slider__container', {
      loop: PROD,
      autoplay: PROD ? 7000 : '',
      effect: 'fade',
      simulateTouch: false,
      preloadImages: false,
      lazyLoading: true,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    });
  });
});


// WEBPACK FOOTER //
// ./src/pages/home/slider/index.js